// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'
import '@firebase/firestore'
import VueCharts from 'vue-charts'
import 'vue-googlemaps/dist/vue-googlemaps.css'
import VueGoogleMaps from 'vue-googlemaps'
import Vue2Filters from 'vue2-filters'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

Vue.use(Vue2Filters)

Vue.use(VueGoogleMaps, {
  load: {
    apiKey: 'AIzaSyCw5_2w24XMbEogtcGCbBCrBw9xXKeJ2eU',
    libraries: ['places']
  }
})

Vue.config.productionTip = false

Vue.use(VueCharts)

let app
const config = {
  apiKey: 'AIzaSyDx_ArqNQtbyQTtojE26chMDlDJcFAQuuw',
  authDomain: 'sun-ray-holdings.firebaseapp.com',
  databaseURL: 'https://sun-ray-holdings.firebaseio.com',
  projectId: 'sun-ray-holdings',
  storageBucket: '',
  messagingSenderId: '108534571256'
}

firebase.initializeApp(config)

export const db = firebase.firestore()

firebase.auth().onAuthStateChanged((user) => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      router,
      template: '<App/>',
      components: { App }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js